import React, { Component } from 'react';
import { DataGrid, GridColumn, Layout, LayoutPanel } from 'rc-easyui';
import axios from 'axios';
import { uAPIlocal } from '../../lib/config';
import parse from "html-react-parser";
import Loader from 'react-loader-spinner';
import Barchart from '../../chart/BarChart';

class Dept extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patient_dept: {
                data: [],
                selection: null,
                loading: true,
            },
            conclusion: null,
            result_grafik: null,
            pasien: null,
        }
        this.getData = this.getData.bind(this);
        this.selectionChange = this.selectionChange.bind(this);
        this.selectionChangeCon = this.selectionChangeCon.bind(this);
    }
    async getData() {
        var id_company = localStorage.getItem("Company_ID");
        await axios.get(uAPIlocal + '/api/v1/patient_dept',{ params: { Company_ID: id_company  } })
            .then(function (response) {
                return response.data.results;
            })
            .then(response => {
                // console.log(response)
                this.setState({
                    patient_dept: {
                        ...this.state.patient_dept,
                        data: response,
                        loading: false
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    async selectionChange(event) {
        // console.log(event)
        await this.setState({
            patient_dept: {
                ...this.state.patient_dept,
                selection: event
            },
            conclusion: {
                data: [],
                loading: true,
            },
            result_grafik: true,
            resultGraphicDept: true,
            pasien: null
        })
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        formData.append('Patient_Dept', this.state.patient_dept.selection.Patient_Dept);
        formData.append('Company_ID',localStorage.getItem("Company_ID"));
        await axios.post(uAPIlocal + '/api/v1/conclusion', formData, config)
            .then(function (response) {
                return response.data.results;
            })
            .then(results => {
                this.setState({
                    conclusion: {
                        data: results,
                        loading: false,
                        selection: null,
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });

        await axios.post(uAPIlocal + '/api/v1/result_grafik_dept', formData, config)
            .then(function (response) {
                return response.data;
            })
            .then(response => {
                const grafik = response.grafik;
                const keterangan = response.keterangan;
                this.setState({
                    grafik: {
                        labels: grafik.kesimpulan,
                        datasets: [
                            {
                                label: "2023",
                                backgroundColor: 'purple',
                                borderColor: 'rgba(0,0,0,1)',
                                borderWidth: 1,
                                data: grafik.a
                            },
                            {
                                label: "2022",
                                backgroundColor: 'green',
                                borderColor: 'rgba(0,0,0,1)',
                                borderWidth: 1,
                                data: grafik.b
                            }, {
                                label: "2021",
                                backgroundColor: 'blue',
                                borderColor: 'rgba(0,0,0,1)',
                                borderWidth: 1,
                                data: grafik.c
                            }, {
                                label: "2020",
                                backgroundColor: 'red',
                                borderColor: 'rgba(0,0,0,1)',
                                borderWidth: 1,
                                data: grafik.d
                            },
                            {
                                label: "2019",
                                backgroundColor: 'black',
                                borderColor: 'rgba(0,0,0,1)',
                                borderWidth: 1,
                                data: grafik.e
                            }
                        ]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {

                                    beginAtZero: true

                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    stepSize: 2,
                                    fontSize: 10,
                                    minRotation: 45
                                }
                            }]
                        },
                        title: {
                            display: true,
                            text: keterangan,
                            fontSize: 14
                        }
                    },
                    resultGraphicDept: false,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    async selectionChangeCon(event) {
        // console.log(event)
        await this.setState({
            conclusion: {
                ...this.state.conclusion,
                selection: event
            },
            pasien: {
                data: [],
                loading: true,
            },
        })
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        // formData.append('2017', this.state.conclusion.selection[2017]);
        // formData.append('2018', this.state.conclusion.selection[2018]);
        // formData.append('2019', this.state.conclusion.selection[2019]);
        // formData.append('Conc_Abn', this.state.conclusion.selection.Conc_Abn);
        // formData.append('Conc_Group', this.state.conclusion.selection.Conc_Group);
        // formData.append('Conc_ID', this.state.conclusion.selection.Conc_ID);
        formData.append('Conc_Name', this.state.conclusion.selection.Conc_Name);
        // formData.append('Conc_Seq', this.state.conclusion.selection.Conc_Seq);
        // formData.append('Patient_DOB', this.state.conclusion.selection.Patient_DOB);
        formData.append('Patient_Dept', this.state.conclusion.selection.Patient_Dept);
        // formData.append('Patient_Gender', this.state.conclusion.selection.Patient_Gender);
        // formData.append('Patient_ID', this.state.conclusion.selection.Patient_ID);
        // formData.append('Patient_NIK', this.state.conclusion.selection.Patient_NIK);
        // formData.append('Patient_id', this.state.conclusion.selection.Patient_id);
        // formData.append('Patient_name', this.state.conclusion.selection.Patient_name);
        formData.append('Company_ID',localStorage.getItem("Company_ID"));

        await axios.post(uAPIlocal + '/api/v1/pasien', formData, config)
            .then(function (response) {
                return response.data.results;
            })
            .then(results => {
                // console.log(results)
                this.setState({
                    pasien: {
                        data: results,
                        loading: false,
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    componentDidMount() {
        this.getData();
        // console.log(this.state)
    }

    render() {
        return (
            <div className='pd-20'>
                <Layout style={{ width: '100%', height: 650 }} >
                    <LayoutPanel region="west" title="Departemen" split collapsible expander style={{ width: 256, }}>
                        {/* {
                            this.state.patient_dept.loading ? (
                                <div className="text-center pd-90" >
                                    <Loader type="Bars" color="#00BFFF" height={60} width={100} />
                                            Loading ...
                                </div>
                            ) : ( */}
                        <DataGrid filterable filterRules={[]} {...this.state.patient_dept} style={{ height: '100%', }} selectionMode='single' selection={this.state.patient_dept.selection} onSelectionChange={this.selectionChange} >
                            <GridColumn field="rn" align="center" width='30px'
                                cellCss="datagrid-td-rownumber" filterable={false}
                                render={({ rowIndex }) => (
                                    <span>{rowIndex + 1}</span>
                                )}
                            />
                            <GridColumn field="Patient_Dept" title="DEPT" align="center" sortable
                                render={({ row }) => {
                                    return parse(`
                                        <div style="text-align: 'center'; white-space: normal;">
                                            ${row.Patient_Dept ? (row.Patient_Dept) : ('')}
                                        </div>
                                    `)
                                }}
                            />
                        </DataGrid>
                        {/* )
                        } */}

                    </LayoutPanel>
                    <LayoutPanel region="center" title="Conclusion" split style={{ height: '100%', }}>
                        {
                            this.state.conclusion ? (
                                <DataGrid {...this.state.conclusion} style={{ height: '100%', }} selectionMode='single' selection={this.state.conclusion.selection} onSelectionChange={this.selectionChangeCon} >
                                    <GridColumn field="rn" align="center" width='30px'
                                        cellCss="datagrid-td-rownumber"
                                        render={({ rowIndex }) => (
                                            <span>{rowIndex + 1}</span>
                                        )}
                                    />
                                    <GridColumn field="Conc_Name" title="Conc Name" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                        <div style="text-align: 'center'; white-space: normal;">
                                            ${row.Conc_Name ? (row.Conc_Name) : ('')}
                                        </div>
                                    `)
                                        }}
                                    />
                                </DataGrid>
                            ) : null
                        }
                    </LayoutPanel>
                    <LayoutPanel region="east" title="Dept Graphic" split collapsible expander style={{ width: 640, }} >
                        {
                            this.state.result_grafik ? (
                                this.state.resultGraphicDept ? (
                                    <div className="text-center pd-90" >
                                        <Loader type="Bars" color="#00BFFF" height={60} width={100} />
                                            Loading ...
                                    </div>
                                ) : (
                                        this.state.grafik ? (
                                            <Barchart type='bar' data={this.state.grafik} options={this.state.options} />
                                        ) : null
                                    )
                            ) : null
                        }
                    </LayoutPanel>
                    <LayoutPanel region="south" split style={{ width: '100%', height: 250 }}>
                        {
                            this.state.pasien ? (
                                <DataGrid {...this.state.pasien} style={{ height: '100%', }} >
                                    <GridColumn field="rn" align="center" width='30px'
                                        cellCss="datagrid-td-rownumber"
                                        render={({ rowIndex }) => (
                                            <span>{rowIndex + 1}</span>
                                        )}
                                    />
                                    <GridColumn field="Patient_NIK" title="NIK" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row.Patient_NIK ? (row.Patient_NIK) : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="Patient_id" title="PID" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row.Patient_id ? (row.Patient_id) : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="Patient_name" title="Patient Name" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row.Patient_name ? (row.Patient_name) : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="Patient_DOB" title="DOB" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row.Patient_DOB ? (row.Patient_DOB) : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="Patient_Gender" title="Gender" align="center" sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row.Patient_Gender ? (row.Patient_Gender) : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                     <GridColumn field="2023" title="2023" align="center" width='60px' sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2023] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="2022" title="2022" align="center" width='60px' sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2022] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="2021" title="2021" align="center" width='60px' sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2021] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    <GridColumn field="2020" title="2020" align="center" width='60px' sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2020] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                     <GridColumn field="2019" title="2019" align="center" width='60px' sortable
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2019] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    />
                                    {/* <GridColumn field="2017" title="2017" align="center" width='60px'
                                        render={({ row }) => {
                                            return parse(`
                                                <div style="text-align: 'center'; white-space: normal;">
                                                    ${row[2017] !== null ? ('✓') : ('')}
                                                </div>
                                            `)
                                        }}
                                    /> */}
                                </DataGrid>
                            ) : null
                        }
                    </LayoutPanel>
                </Layout>
            </div>
        )
    }
}
export default Dept;